var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarSmily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "0.910949in",
    height: "0.918146in",
    viewBox: "0 0 1729 1742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .str0 {stroke:#999999;stroke-width:13.1707;stroke-linecap:round;stroke-linejoin:round}\n      .fil0 {fill:none}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M634 1253c-18,-22 -56,-65 -74,-97 -26,-45 -20,-58 -34,-84 -5,-10 -22,59 -70,-76 -25,-64 -57,-172 -60,-233 5,-39 45,-26 67,-38 -140,-297 -31,-302 -36,-352 -19,-177 30,-279 238,-350 131,-44 360,11 508,51l-75 15c153,31 231,92 276,195 85,192 9,323 -4,412l-23 -44c-12,-25 -5,-16 -17,-35l-45 133c30,-7 50,-1 52,31 -23,74 -32,138 -62,210 -22,62 -36,94 -63,53 -33,97 -67,151 -120,209 -51,54 -132,182 -229,146 -74,28 -193,-104 -229,-146zm413 -200c-66,30 -105,71 -186,70 -70,-1 -119,-49 -180,-70 135,8 252,12 366,0zm-1040 683c54,-102 151,-106 252,-136 170,-50 259,-74 295,-120 36,-46 43,-91 80,-227 54,64 150,171 229,146 76,28 174,-82 229,-146 50,143 37,189 83,233 32,30 235,87 292,105 111,35 202,48 255,145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSmily);
export default __webpack_public_path__ + "static/media/AvatarSmily.9958b6a81966a1affa109a058ede9a04.svg";
export { ForwardRef as ReactComponent };